<template>
  <sidebar-items-list
      ref="list"
      :api-url="apiUrl"
      :back-to="{ name: 'projects.components.floors.show', params: { projectId, componentId, floorId } }"
      :header="$t('Room constructions')"
      model-type="wall"
  >
    <template #header="{newItem}">
      <b-dropdown
          v-if="$gate.allow('create', 'wall')"
          id="new_room_construction"
          :disabled="newItem.busy"
          :text="$t('New room construction')"
          right
          variant="primary"
      >
        <b-dropdown-item-button @click="handleCreate(WALL_TYPES.WALL)">
          <div class="d-flex flex-nowrap justify-between w-100">
            <span>{{ $t('Create new wall') }}</span>
            <fa class="ml-3" icon="plus" />
          </div>
        </b-dropdown-item-button>

        <b-dropdown-item-button @click="handleCreate(WALL_TYPES.CEILING)">
          <div class="d-flex flex-nowrap justify-between w-100">
            <span>{{ $t('Create new ceiling') }}</span>
            <fa class="ml-3" icon="plus" />
          </div>
        </b-dropdown-item-button>

        <b-dropdown-item-button @click="handleCreate(WALL_TYPES.GROUND)">
          <div class="d-flex flex-nowrap justify-between w-100">
            <span>{{ $t('Create new ground') }}</span>
            <fa class="ml-3" icon="plus" />
          </div>
        </b-dropdown-item-button>

        <b-dropdown-item-button @click="handleCreate(WALL_TYPES.PIER)">
          <div class="d-flex flex-nowrap justify-between w-100">
            <span>{{ $t('Create new pier') }}</span>
            <fa class="ml-3" icon="plus" />
          </div>
        </b-dropdown-item-button>

        <b-dropdown-item-button @click="handleCreate(WALL_TYPES.ROUND_PIER)">
          <div class="d-flex flex-nowrap justify-between w-100">
            <span>{{ $t('Create new round pier') }}</span>
            <fa class="ml-3" icon="plus" />
          </div>
        </b-dropdown-item-button>

        <b-dropdown-item-button @click="handleCreate(WALL_TYPES.TRAPEZOID)">
          <div class="d-flex flex-nowrap justify-between w-100">
            <span>{{ $t('Create new trapezoid') }}</span>
            <fa class="ml-3" icon="plus" />
          </div>
        </b-dropdown-item-button>
      </b-dropdown>
    </template>
  </sidebar-items-list>
</template>
<script>
import {WALL_TYPES} from '@/constants';
import SidebarItemsList from "@/components/SidebarItemsList";
export default {
  name: 'Walls',
  components: {SidebarItemsList},
  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
    componentId: {
      type: [Number, String],
      required: true,
    },
    floorId: {
      type: [Number, String],
      required: true,
    },
    roomId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      WALL_TYPES,
    };
  },
  computed: {
    apiUrl() {
      return `/api/projects/${this.projectId}/components/${this.componentId}/floors/${this.floorId}/rooms/${this.roomId}/walls`;
    },
  },

  methods: {
    async handleCreate(type = 'wall') {
      let item = await this.axios.post(this.apiUrl, {type}).then(({data}) => data);
      this.$refs.list.items.push(item);
    },
  },
};
</script>
